import LockupPreviewButton from './lockupPreviewButton'

export default LockupPreviewButton
